import { useEffect, useState } from 'react';
import { MainLayout } from 'components';
import { Col, Form, Input, Row, Space, Table, DatePicker, Select } from 'antd';
import Button from 'components/Button';
import {
  AddIcon,
  EditIcon,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
} from 'assets/svg';
import { useHistory, useLocation } from 'react-router-dom';
import { Content } from 'antd/es/layout/layout';
import useQueryParam from 'hooks/useQueryPrams';
import { HocChangePagination } from 'utils/HocChangePagination';
import { IGetUserQuery } from 'interface/user.interface';
import formatDateWithTime from 'utils/formatDateWithTime';
import { useQuery } from 'react-query';
import { Iapprove } from 'interface/approve.interface';
import ApprovalApi from 'apis/ApprovalApi';
import pageTitleStore from 'store/pageTitleStore';
import { useFormik } from 'formik';
import formatDateMDY from 'utils/formatDateMDY';
import { ColumnsType } from 'antd/es/table';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';

export default function DepartmentApproval() {
  const history = useHistory();
  const queryParam = useQueryParam();
  const location = useLocation();

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const functionParams = {
    page: page,
    page_size: page_size,
  };

  const params = JSON.parse(JSON.stringify(functionParams));

  const [dataSource, SetDataSource] = useState<Array<number>>([0, 0, 0, 0]);

  const {
    data: result,
    isLoading,
    refetch,
  } = useQuery(['searchApproval', params, dataSource], () =>
    ApprovalApi.searchApproval(dataSource, params)
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      division_id: 0,
      created_date: [],
      created_by: '',
    },
    onSubmit(values) {
      const newDivisionId =
        values?.division_id === undefined ? 0 : values?.division_id;
      const checkDateValues = () => {
        if (values?.created_date === null || values?.created_date.length == 0) {
          return [0, 0];
        } else {
          return [
            formatDateMDY(values?.created_date[0]),
            formatDateMDY(values?.created_date[1]),
          ];
        }
      };
      const createBy = values?.created_by === '' ? 0 : values?.created_by;

      const newValues = [newDivisionId, createBy, ...checkDateValues()];

      SetDataSource((): Array<any> => newValues);
    },
  });

  const handleChangeSelect = (name: string) => {
    return (value: any) => {
      formik.setFieldValue(name, value);
    };
  };

  const { data: resultDivision } = useQuery(['getAllDivision'], () =>
    ApprovalApi.getAllDivision()
  );
  const renderDivisionOptions = (divisionList: Array<any>) => {
    return divisionList.map((item) => {
      return (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      );
    });
  };

  const search = queryParam.get('search') || undefined;
  const fullName = queryParam.get('fullName') || undefined;
  const email = queryParam.get('email') || undefined;
  const jobTitleCode = queryParam.get('jobTitleCode') || undefined;
  const departmentCode = queryParam.get('departmentCode') || undefined;
  const plantCode = queryParam.get('plantCode') || undefined;

  const categoryParams: IGetUserQuery = {
    page,
    page_size,
    search,
    fullName,
    email,
    jobTitleCode,
    departmentCode,
    plantCode,
  };
  const { data, isLoading: getUsersLoading } = useQuery({
    queryKey: ['getUsers', categoryParams],
    queryFn: () => {
      return { data: [] as Iapprove[], total: 0 };
    },
    select: (data: any) => {
      if (data?.data?.length <= 0) {
        data.data = result?.data;
      }
      return data;
    },
  });

  type FixedType = 'left' | 'right' | boolean;

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 100,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Khối phát hành',
      dataIndex: 'release_block',
      width: 200,
      render: (_: any, record: Iapprove) => {
        return record?.division?.name;
      },
    },
    {
      title: 'Công ty phát hành',
      dataIndex: 'division_id',
      width: 180,
    },
    {
      title: 'Danh mục',
      width: 150,
      render: (_: any, record: Iapprove) => {
        return record?.pof_type?.pof_type_name;
      },
    },
    {
      title: 'Người tạo',
      width: 180,
      render: (_: any, record: Iapprove) => {
        return record?.user_created?.fullName;
      },
    },
    {
      title: 'Người cập nhật cuối',
      width: 180,
      render: (_: any, record: Iapprove) => {
        return record?.user_updated?.fullName;
      },
    },
    {
      title: 'Cập nhật lần cuối',
      dataIndex: 'updated_at',
      width: 200,
      render: (_: any, record: Iapprove) => {
        if (record?.updated_at === null) {
          return '-';
        } else {
          return formatDateWithTime(record?.updated_at);
        }
      },
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 100,
      render: (record: Iapprove) => (
        <div className="flex justify-around">
          <button
            onClick={() => {
              history.push(`/department-approval/detail/${record.id}`);
            }}
          >
            <EyeIcon />
          </button>
          <button
            onClick={() => {
              history.push(`/department-approval/edit/${record.id}`);
            }}
          >
            <EditIcon />
          </button>
        </div>
      ),
    },
  ];
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  useEffect(() => {
    setTitle('Phê duyệt');
    setBreadcrumb([{ title: <a href="/department-approval">Phê duyệt</a> }]);
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
  }, [functionParams]);

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
    SetDataSource([0, 0, 0, 0]);
  };

  const { RangePicker } = DatePicker;

  return (
    <MainLayout isLoading={isLoading}>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
        <Col span={12} className="flex justify-end">
          <Space>
            <Button
              onClick={() => {
                history.push(`/department-approval/addnew`);
              }}
            >
              <AddIcon />
              Tạo mới
            </Button>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>

      <Form
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'}`}
        onSubmitCapture={formik.handleSubmit}
        autoComplete="off"
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item label="Khối phát hành">
                <Select
                  allowClear={true}
                  placeholder="Tìm kiếm theo khối phát hành"
                  size="large"
                  onChange={handleChangeSelect('division_id')}
                >
                  {renderDivisionOptions((resultDivision?.data || []) as any)}
                </Select>
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item label="Ngày tạo">
                <RangePicker
                  onChange={handleChangeSelect('created_date')}
                  placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                  size="small"
                  format={'DD/MM/YYYY'}
                />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item label="Người tạo">
                <Input
                  onChange={formik.handleChange}
                  name="created_by"
                  placeholder="Nhập email người tạo"
                  className=""
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={toggleFilter}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          scroll={{ x: 958 }}
          className="customTable"
          dataSource={result?.data}
          loading={getUsersLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: data?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
